import {
  List,
  ListMutationArgs,
  Media,
  ProductReference,
} from '@epicuro-next/models/engagement';

import { ProductListType } from '../../models';
import {
  AccountSiteDto,
  ProductListProductDto,
  ProductReferenceDto,
} from '../common-dto';
import { EngagementCommercialProductReference } from '../mapped-to-engagement-dto';
import { ProductListResponseDto } from '../response-dto';

import { MediaRequestDto } from './media-request.dto';

export interface ProductListsGetRequestDto extends AccountSiteDto {
  page?: number;
  size?: number;
}

export interface ProductListUpdateRequestDto extends AccountSiteDto {
  list: Partial<List>;
  media?: Media;
}

export interface ProductListReOrderProductRequestDto {
  productListId: string;
  productId: string;
  brandId: string;
  order: number;
}

export interface ProductListGetRequestDto extends AccountSiteDto {
  productListId: string;
}

export interface ProductListDeleteRequestDto {
  id: string;
  deleteFromLookBook?: boolean;
}

interface ProductListCloneBodyDto {
  id: string;
  name?: string;
  description?: string;
}

export type ProductListCloneRequestDto = AccountSiteDto &
  ProductListCloneBodyDto;

export type ProductListProductWithAccountRequestDto = ProductListProductDto &
  AccountSiteDto;

export interface ProductListGetProductsRequestDto {
  query: ProductListProductWithAccountRequestDto;
  // tslint:disable-next-line:bool-param-default
  cacheFirst?: boolean;
}

export interface ProductListItemsPatchDto {
  itemsToAdd: ProductReferenceDto[];
  itemsToDelete: ProductReferenceDto[];
}

export interface ProductListChangeProductRequestDto {
  id: string;
  patchItems: ProductListItemsPatchDto;
  orderType?: string;
  stylesOnly?: boolean;
}

export interface ProductListBulkDeleteRequestDto {
  ids: string[];
  deleteFromLookBook?: boolean;
}

export interface ProductListBaseAddRequestDto
  extends AccountSiteDto,
    Omit<ListMutationArgs, 'productReferences'> {
  productReferences?: (ProductReference & { isAvailable?: boolean | null })[];
  stylesOnly?: boolean;
  layout?: any;
}

export interface ProductListAddRequestDto
  extends Omit<
    ProductListBaseAddRequestDto,
    'productReferences' | 'type' | 'media'
  > {
  type: ProductListType;
  productReferences?: EngagementCommercialProductReference[];
  stylesOnly?: boolean;
  media?: MediaRequestDto;
}

export interface BaseProductListRequestDto {
  name: string;
  description?: string;
}

export interface ProductsLoadAvailabilitiesRequestDto extends AccountSiteDto {
  lists: ProductListResponseDto[];
}

export enum ProductListGroupingType {
  None = 'none',
  Category = 'category',
}
